import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";
import type {
	ClientExpenseListItemResponseDTO,
	ClientIncomeDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export const mapIncomeToFinanceState = (
	income: ClientIncomeDetailResponseDTO,
): FinanceState["income"][number] => ({
	id: income.id,
	name: income.name ?? "",
	amount: income.amount,
});

export const mapExpenseToFinanceState = (
	expense: ClientExpenseListItemResponseDTO,
): FinanceState["expenses"][number] => ({
	id: expense.id,
	type: expense.type,
	name: expense.name,
	monthlyPayment: expense.monthlyPayment,
	sustainableAmount: expense.sustainableAmount,
});
